<template>
    <picture>
        <template v-for="(srcSet, index) in sourceSet">
            <source
                v-if="srcSet.size != undefined"
                :key="`${index}/${srcSet.path}`"
                :media="`(max-width: ${srcSet.size}px)`"
                :srcset="`${srcSet.path}`"
                :type="`image/${srcSet.format}`"
            />

            <source
                v-if="sizes.length > 0 && srcSet.size === undefined"
                :key="`${index}/${srcSet.path}`"
                :media="`(min-width: ${Number(sizes[sizes.length - 1]) + 1}px)`"
                :srcset="`${srcSet.path}`"
                :type="`image/${srcSet.format}`"
            />
            <source
                v-if="sizes.length <= 0 && srcSet.size === undefined"
                :key="`${index}/${srcSet.path}`"
                :srcset="`${srcSet.path}`"
                :type="`image/${srcSet.format}`"
            />
        </template>

        <img
            id="myImage"
            :src="`${defaultImg.path}`"
            :alt="alt"
            :fileName="fileName"
            draggable="false"
            :loading="load"
            @load="loaded"
            @error="failed"
        />
    </picture>
</template>

<script>
export default {
    name: 'ImageOptimized',
    props: {
        sizes: {
            type: Array,
            default: () => [],
        },
        thumbSizes: {
            type: String,
            default: null,
        },
        specPaths: {
            type: Array,
            default: null,
        },
        alt: {
            type: String,
            default: 'image',
        },
        fileName: {
            type: String,
            default: null,
        },
        load: {
            type: String,
            default: 'auto',
        },
    },
    data() {
        return {
            sourceSet: [],
            defaultImg: {},
        };
    },
    mounted() {
        this.imgObjs();
    },
    methods: {
        loaded() {
            this.$emit('loaded');
        },
        failed() {
            this.$emit('failed');
        },
        imgObjs() {
            const reqImgs = require.context(
                'Images',
                true,
                /\.(png|jpe?g|svg|webp)$/
            );

            const paths = reqImgs.keys();
            let specPath;
            let sourceSet = [];
            let format;
            let size;

            paths.map(path => {
                if (path.includes(this.fileName)) {
                    specPath = reqImgs(path);
                    this.getSourceSet(specPath, format, sourceSet, size);
                }
            });

            sourceSet.map(defaultImg => {
                if (
                    defaultImg.size === undefined &&
                    defaultImg.format != 'webp'
                ) {
                    this.defaultImg = defaultImg;
                }
            });

            this.sortSourceSet(sourceSet);

            this.sourceSet = sourceSet;
            return this.sourceSet;
        },
        getSourceSet(specPath, format, sourceSet, size) {
            if (specPath.includes('webp')) {
                format = 'webp';
            } else if (specPath.includes('png')) {
                format = 'png';
            } else if (specPath.includes('jpg')) {
                format = 'jpg';
            } else if (specPath.includes('jpeg')) {
                format = 'jpeg';
            } else if (specPath.includes('JPG')) {
                format = 'JPG';
            } else if (specPath.includes('JPEG')) {
                format = 'JPEG';
            }

            if (this.sizes)
                this.sizes.map(imgSize => {
                    if (specPath.includes(imgSize)) {
                        size = imgSize;
                    }
                });

            sourceSet.push({
                path: specPath,
                format: format,
                size: size,
            });
            this.sourceSet = sourceSet;
        },

        sortSourceSet(sourceSet) {
            sourceSet.sort((a, b) => {
                return a.size - b.size;
            });

            for (let i = 0; i < sourceSet.length; i++) {
                if (
                    sourceSet[i].size !== undefined &&
                    sourceSet[i].size === sourceSet[i + 1].size
                ) {
                    let firstIndex = sourceSet[i];
                    sourceSet[i] = sourceSet[i + 1];
                    sourceSet[i + 1] = firstIndex;
                } else if (sourceSet[i].size === undefined) {
                    let firstIndex = sourceSet[i];
                    sourceSet[i] = sourceSet[i + 1];
                    sourceSet[i + 1] = firstIndex;
                }
                i = i + 1;
            }
        },
    },
};
</script>

<style scoped lang="scss">
picture {
    img {
        width: 100%;
    }
}
</style>
